import {Typography} from "@mui/material"
import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const MiniShoppingBagContainer = styled("div")`
    color: ${({theme}) => theme.uxfabric.text.primary};
    display: flex;
    flex-direction: column;
    background-color: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.backgroundColor};
    width: 20rem;
    text-transform: none;
    border-bottom-left-radius: ${({theme}) => theme.uxfabric.shape.global.popover.default.borderRadius};
    border-bottom-right-radius: ${({theme}) => theme.uxfabric.shape.global.popover.default.borderRadius};
`
export const TotalText = styled("div")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
`

export const TotalValue = styled(Typography)`
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
`

export const MiniShoppingBagPriceWrapper = styled("div")`
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    border: 0.0625rem solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    border-bottom: unset;
    background-color: ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.backgroundColor};
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-size: ${({theme}) => `${theme.uxfabric.global.body3.fontSize}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    line-height: ${({theme}) => `${theme.uxfabric.global.body3.lineHeight}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body3.letterSpacing}`};
`

export const ItemCountWrapper = styled("div")`
    font-family: ${({theme}) => `${theme.uxfabric.global.subtitle2.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.subtitle2.fontWeight}`};
    font-size: ${({theme}) => `${theme.uxfabric.global.subtitle2.fontSize}`};
    padding: 0.25rem 1rem 0.625rem;
    background: ${({theme}) => theme.uxfabric.components.dialog.dialogHeader.default.backgroundColor};
    text-transform: none;
    border: 0.0625rem solid ${({theme}) => `${theme.uxfabric.components.dialog.dialogContent.default.borderColor}`};
    border-top: unset;
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.subtitle2.letterSpacing}px`} !important;
`

export const EmptyBagWrapper = styled("div")`
    height: 4.313rem;
    background-color: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.backgroundColor};
    border-width: 0 0.0625rem;
    border-style: solid;
    border-color: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.borderColor};
    align-items: center;
    justify-content: center;
    display: flex;
`

export const EmptyBagTextWrapper = styled(Typography)`
    font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body1.fontWeight}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body1.letterSpacing}`};
    font-size: ${({theme}) => `${theme.uxfabric.global.body1.fontSize}`};
    line-height: ${({theme}) => `${theme.uxfabric.global.body1.lineHeight}`};
    color: ${({theme}) => theme.uxfabric.text.primary};
`

export const CTAContainer = styled("div")`
    flex: 1 1 auto;
    align-self: center;
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    font-family: ${({theme}) => theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY};
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    line-height: ${({theme}) => theme.uxfabric.component.buttonMedium.lineHeight};
    height: 2.25rem;
    min-width: 8.625rem;
`

export const ActionWrapper = styled("div")`
    background: ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.backgroundColor};
    border: 0.0625rem solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    border-top: unset;
    border-radius: inherit;
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    padding: 1rem 0.938rem;
`

export const CartItemsContainer = styled("div")`
    display: flex;
    flex-direction: column;
`
